<script>
import RbxDatePicker from '../../../shared/reybex/RbxDatePicker';
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'AffiliatePrivacyOfficerForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxDatePicker,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    affiliate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'affiliate',
      showDateMenu: false,
    };
  },
  created() {
    if (!this.affiliate.privacyOfficer) {
      this.affiliate.privacyOfficer = {};
    }
  },
  methods: {
    onDateInput(newDate) {
      this.affiliate.privacyOfficer.requestDate = newDate;
    },
  },
};
</script>

<template>
  <div class="affiliate-detail-tab main-tab">
    <v-layout row wrap>
      <!-- Basic information left column -->
      <v-flex md8 xs12>
        <h4 class="affiliate-detail-tab-title">Allgemein</h4>
        <v-layout row wrap>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.name')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.name"
              label="Name des Datenschutzbeauftragten"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.firm')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.firm"
              label="Firma"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.street')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.street"
              label="Straße"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.zip')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.zip"
              label="PLZ"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.location')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.location"
              label="Ort"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.phone')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.phone"
              label="Telefon"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.fax')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.fax"
              label="Fax"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.email')" md4 py-0>
            <v-text-field
              v-model="affiliate.privacyOfficer.email"
              label="E-Mail-Adresse"
              height="22"
              class="caption"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.requestDate')" md4 py-0>
            <rbx-date-picker
              :value="affiliate.privacyOfficer.requestDate"
              label="Bestellungsdatum zum Datenschutzbeauftragten"
              @input="onDateInput"
            />
          </v-flex>

          <v-flex v-if="isFieldVisible('affiliate.privacyOfficer.isInternal')" md4 py-0>
            <v-switch
              v-model="affiliate.privacyOfficer.isInternal"
              label="intern Angestellt"
              height="0"
            />
          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
